<template>
  <div class="prescription-start-form">
    <div class="prescription-start-title">
      <strong>{{ prescription.drug.name }}</strong>

      {{ prescription.drug.measure }}
      {{ prescription.drug.measureUnit }}

      {{ prescription.drug.manufacturer ? prescription.drug.manufacturer.name : '' }}
    </div>

    <div v-if="loading" class="prescription-start-loader">
      <div class="loader"></div>
    </div>

    <div v-if="!loading" class="prescription-start-selector">
      <div>Выбрать дату начала приема: <small>{{error}}</small></div>

      <div class="prescription-start-selector-items">
        <div class="prescription-start-selector-item">
          <i class="fas fa-sort-up prescription-start-selector-button prescription-start-selector-button-prev"
             @click="changeDate('d', 1)"></i>
          {{date}}
          <i class="fas fa-sort-down prescription-start-selector-button prescription-start-selector-button-next"
             @click="changeDate('d', -1)"></i>
        </div>

        <div class="prescription-start-selector-item">
          <i class="fas fa-sort-up prescription-start-selector-button prescription-start-selector-button-prev"
             @click="changeDate('m', 1)"></i>
          {{month}}
          <i class="fas fa-sort-down prescription-start-selector-button prescription-start-selector-button-next"
             @click="changeDate('m', -1)"></i>
        </div>

        <div class="prescription-start-selector-item">
          <i class="fas fa-sort-down prescription-start-selector-button prescription-start-selector-button-next"
             @click="changeDate('y', -1)"></i>
          {{year}}
          <i class="fas fa-sort-up prescription-start-selector-button prescription-start-selector-button-prev"
             @click="changeDate('y', 1)"></i>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="prescription-start-buttons">
      <div class="prescription-start-button-row">
        <div class="prescription-start-button prescription-start-button-start"
             @click="start">Начать</div>
      </div>

      <div class="prescription-start-button-row">
        <div class="prescription-start-button prescription-start-button-cancel"
             @click="selectPrescription(null)">Отменить</div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../utils/formatDate';

  export default {
    name: 'PrescriptionStart',

    props: ['prescription', 'selectPrescription', 'startPrescription'],

    data() {
      return {
        error: '',
        selectedDate: new Date(),
        loading: false,
      };
    },

    computed: {
      date() {
        return formatDate(this.selectedDate, 'd');
      },

      month() {
        return formatDate(this.selectedDate, 'm');
      },

      year() {
        return formatDate(this.selectedDate, 'y');
      },
    },

    methods: {
      async start() {
        this.loading = true;

        await this.startPrescription(this.prescription.id, this.selectedDate);

        this.loading = false;
      },

      changeDate(type, value) {
        if (type === 'y') {
          this.selectedDate.setFullYear(this.selectedDate.getFullYear() + value);
        }

        if (type === 'm') {
          this.selectedDate.setMonth(this.selectedDate.getMonth() + value);
        }

        if (type === 'd') {
          this.selectedDate.setDate(this.selectedDate.getDate() + value);
        }

        this.selectedDate = new Date(this.selectedDate.getTime());
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .prescription-start-form {
    padding: 20px 20px 0;
    user-select: none;

    .prescription-start-title {
      height: 50px;
      padding: 0;
      margin: 0 0 10px;

      strong {
        font-size: 16px;
        color: $primary;
      }
    }

    .prescription-start-loader {
      margin-top: 60px;
    }

    .prescription-start-selector {
      height: 140px;
      padding: 0;

      small {
        color: $text-error;
      }

      .prescription-start-selector-items {
        padding: 30px 0 0;
        text-align: center;

        .prescription-start-selector-item {
          position: relative;
          display: inline-block;
          margin: 0 2px;
          padding: 7px 10px 5px;
          font-size: 24px;
          font-weight: bold;
          line-height: 24px;
          color: $primary;
          border: 2px solid $primary;
          border-radius: 5px;

          .prescription-start-selector-button {
            position: absolute;
            left: 50%;
            width: 15px;
            margin-left: -7px;
          }

          .prescription-start-selector-button-prev {
            top: -20px;
          }

          .prescription-start-selector-button-next {
            bottom: -20px;
          }
        }
      }
    }

    .prescription-start-buttons {
      text-align: justify;

      .prescription-start-button-row {
        display: inline-block;
        width: 50%;
      }

      .prescription-start-button {
        padding: 7px 10px 5px;
        border: 2px solid $primary;
        border-radius: 5px;
        text-align: center;
      }

      .prescription-start-button-start {
        margin: 0 5px 0 0;
        color: $white;
        background-color: $primary;
      }

      .prescription-start-button-cancel {
        margin: 0 0 0 5px;
        color: $primary;
      }
    }
  }
</style>
